import React, { useRef, useState, useMemo, useCallback } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import { __ } from '../../../tools';
import Calendar from '../../../../assets/icons/calendar';
import clsx from 'clsx';
import style from './style.module.scss';

export const Input = ({
    id = '',
    name = '',
    required = false,
    type = 'text',
    label = null,
    placeholder = null,
    errors = [],
    ...props
}) => {
    const [selectedFlag, setSelectedFlag] = useState('FR');
    const dateInputRef = useRef(null);

    const err = errors.filter((el) => el.field === name);

    const handleCalendarOnClick = useCallback(() => {
        dateInputRef.current && dateInputRef.current.showPicker();
    }, [dateInputRef]);

    const inputProps = useMemo(() => {
        let props = {
            className: clsx(style.input, style[type]),
            type: type,
            required: required,
        };

        if (placeholder) props.placeholder = placeholder;
        if (name) props.name = name;
        if (id) props.id = id;
        if (type === 'date') {
            props.ref = dateInputRef;
            props.onClick = handleCalendarOnClick;
        }

        return props;
    }, [type, required, placeholder, name, id, dateInputRef, handleCalendarOnClick]);

    return (
        <div {...props} className={clsx(style.block, props.className)}>
            {label && (
                <label htmlFor={id ? id : undefined} className={clsx(style.label, required && style.required)}>
                    {label}
                </label>
            )}
            {type === 'tel' && (
                <>
                    <input type="hidden" name={name + '_country'} value={selectedFlag} />
                    <ReactFlagsSelect
                        selected={selectedFlag}
                        onSelect={setSelectedFlag}
                        className={style.flags}
                        placeholder={__('Sélectionnez un pays')}
                        showSelectedLabel={false}
                        searchable
                        searchPlaceholder={__('Rechercher')}
                    />
                </>
            )}
            {type === 'date' && <Calendar className={style.calendarIcon} />}
            <input {...inputProps} />
            {err && err.length ? <div className={style.error}>{err[0].message}</div> : <></>}
        </div>
    );
};

export default Input;
